import React from "react";
import { motion } from "framer-motion";
import { FaGraduationCap } from "react-icons/fa";
import { sectionVariants, itemVariants } from "../../constants/animations";
import { EDUCATION } from "./Education.constants";

const Education: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6 bg-slate-800/30"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-center gradient-text">
          Education
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          {EDUCATION.map((edu) => (
            <motion.div
              key={edu.degree}
              variants={itemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="glass rounded-2xl p-6 gradient-border"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center flex-shrink-0">
                  <FaGraduationCap className="text-2xl text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">
                    {edu.degree}
                  </h3>
                  <p className="text-blue-400">{edu.school}</p>
                  <p className="text-sm text-slate-400">
                    {edu.location} | {edu.period}
                  </p>
                  {edu.gpa && (
                    <p className="text-sm text-green-400 font-medium mt-1">
                      GPA: {edu.gpa}
                    </p>
                  )}
                </div>
              </div>
              <ul className="mt-4 space-y-1">
                {edu.highlights.map((highlight) => (
                  <li
                    key={highlight}
                    className="text-sm text-slate-400 flex items-start gap-2"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-blue-400 mt-1.5 flex-shrink-0" />
                    {highlight}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Education;
